import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  clear(_event) {
    this.formTarget.submit()
  }
}
